import { isPlatformServer } from '@angular/common';
import { Component, Inject, makeStateKey, OnInit, PLATFORM_ID, TransferState } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { MateriasApiService } from '@modules/materias/materias-api.service';
import { FunctionsService } from '@shared/services/functions.service';
import { SeoMetadataService } from '@shared/services/seo-metadata.service';
import { tap } from 'rxjs';

const MATERIAS_KEY = makeStateKey<any>('MATERIAS');

@Component({
  selector: 'astrea-materias',
  templateUrl: './materias.component.html',
  styleUrls: ['./materias.component.scss']
})
export class MateriasComponent implements OnInit {

  public allMaterias!: any[];
  public materias!: any[];
  public loading = true;

  public itemsPerPage: number = 50;
  public filters = {
    limit: this.itemsPerPage,
    offset: 0
  };

  public formSearch = this.formBuilder.group({
    materia: [null, Validators.required],
  });

  constructor(
    public functionsService: FunctionsService,
    private formBuilder: UntypedFormBuilder,
    private seo: SeoMetadataService,
    private api: MateriasApiService,
    private transferState: TransferState,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit(): void {
    this.setMetadata();
    this.loadMaterias();
  }

  setMetadata(): void {
    this.seo.setMetadata({
      title: 'Materias',
      description: 'Categorias de materia de todas nuestras obras.',
      relativeUrl: '/materias'
    });
  }

  filterMaterias(text: any): void {
    if (!text) {
      this.materias = this.allMaterias;
    } else {
      const t = new RegExp(`${this.functionsService.accentsIgnore(text.toLowerCase())}`, 'i');
      this.materias = this.allMaterias.filter((c: any) => {
        if (t.exec(c.legalMatter))
          return true;
        else
          return false;
      });
    }
  }

  loadMaterias(): void {
    const cachedData = this.transferState.get(MATERIAS_KEY, null);
    if (cachedData) {
      this.allMaterias = cachedData.result.data;
      this.materias = cachedData.result.data;
      this.loading = false;
    } else {
      this.getMaterias();
    }
  }

  getMaterias(): void {
    this.loading = true;
    this.api.getMaterias()
      .pipe(
        tap(data => {
          if (isPlatformServer(this.platformId)) {
            this.transferState.set(MATERIAS_KEY, data);
          }
        })
      )
      .subscribe({
        next: res => {
          this.allMaterias = res.result.data;
          this.materias = res.result.data;
          this.loading = false;
        }
      });
  }

}
